import { KycProcessStatus, type KycResponse } from '@repo/api-kit/queries/due-diligence/kyc';

export function isPersonalInfoProvided(kycInfo?: KycResponse | null) {
  return kycInfo?.activeProcess?.processStatus !== KycProcessStatus.pending_personal_info;
}
